import useSWR, { SWRResponse } from "swr";
import { IUseOverview } from "./types";
import { IPortfolioDetails } from "@portal/types/api/IPortfolioDetails";
import { IOverview } from "@portal/types/api/IOverview";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";

const useOverview: IUseOverview = () => {
  const { update } = useSession();

  const fetcher = async (url: URL) => {
    const res = await fetch(url, {
      method: "GET",
      headers: [["accepts", "application/json"]],
    });

    if (res.status === 404) {
      return {
        amlStatusCode: "",
        canTrade: false,
        totalBalance: 0,
        totalMarketValue: 0,
        savingAgreementsCount: 0,
        savingsPercentile: 0,
        totalYearlySavings: 0,
        totalPositionValue: 0,
        totalUnrealizedProfit: 0,
        totalUnrealizedProfitPercent: 0,
        customerOverviews: [],
      };
    }

    if (res.status !== 200) {
      throw res.status;
    }

    return res.json();
  };
  const { data, error, isLoading, mutate }: SWRResponse<IOverview, unknown> = useSWR(
    `/api/overview`,
    fetcher,
    commonSwrConfig(update),
  );

  const positionForAllAccounts = data?.customerOverviews?.flatMap(co => co.positions);

  const portfolios = data?.customerOverviews.map(co => {
    return {
      centerId: co.centerId,
      balance: co.balance,
      canTradeFunds: co.canTradeFunds,
      portfolioId: co.portfolioId,
      portfolioName: co.portfolioName,
      positionsValue: co.positionsValue,
      unrealizedProfit: co.unrealizedProfit,
      unrealizedProfitPercent: co.unrealizedProfitPercent,
      yearlySavings: co.yearlySavings,
      taxationType: co.taxationType,
      marketValue: co.marketValue,
      feeAmount: co.feeAmount,
      feePercent: co.feePercent,
    } as IPortfolioDetails;
  });

  return {
    data,
    positionForAllAccounts,
    portfolios,
    error,
    isLoading,
    mutate,
  };
};

export default useOverview;
